import axios from "axios";
import { SERVER_URL } from "../socket";

export async function getLinkedAccounts(headers) {
  const res  = await fetch(`${window.SERVER_URL || ""}/api/accounts/linked`, { headers });
  const data = await res.json();
  if (!data.success) throw new Error(data.error);

  // Map server fields → component fields
  return data.accounts.map(acc => ({
    linkId:          acc.linkId,
    id:              acc.linkId,          // keep for safety
    userId:          acc.userId,
    fullName:        acc.fullName  || "",
    profileImageUrl: acc.profileImageUrl || "",  // ← this must be forwarded
    switchToken:     acc.switchToken,
  }));
}

export async function linkAccount(username, password, headers) {
  const res  = await fetch(`${window.SERVER_URL || ""}/api/accounts/link`, {
    method: "POST",
    headers: { "Content-Type": "application/json", ...headers },
    body: JSON.stringify({ username, password }),
  });
  const data = await res.json();
  if (!data.success) throw { response: { data } };
  return {
    linkId:          data.account.linkId  || null,
    userId:          data.account.userId,
    fullName:        data.account.fullName        || "",
    profileImageUrl: data.account.profileImageUrl || "",
    switchToken:     data.account.switchToken,
  };
}

export async function removeLinkedAccount(linkId, headers) {
  const res = await fetch(`${window.SERVER_URL || ""}/api/accounts/linked/${linkId}`, {
    method: "DELETE",
    headers,
  });
  return res.json();
}

export async function switchAccount(switchToken, headers) {
  const res = await fetch(`${window.SERVER_URL || ""}/api/accounts/switch`, {
    method: "POST",
    headers: { "Content-Type": "application/json", ...headers },
    body: JSON.stringify({ switchToken }),
  });
  return res.json();
}

